import { CSSObject } from '@chakra-ui/react';
import { TAccordionButton, TAccordionItem } from './MarketsByMatch.styles';

export const BoxWrapper: CSSObject = {
  px: ['2', '3'],
};

export const AccordionItem = ({ isNested }: TAccordionItem): CSSObject => ({
  boxShadow: 'none',
  border: 0,
  mb: '2',

  _expanded: {
    boxShadow: 'none',
  },

  ...(isNested && {
    boxShadow: 'none',

    _last: { mb: 0 },
  }),
});

export const AccordionPanel = () => ({
  borderWidth: '1px',
  borderColor: 'alpha.500',
  borderTop: 0,
  bg: 'alpha.600',
  borderBottomRadius: 'base',
  px: '1',
  py: '2',
});

export const AccordionButton = ({ isNested }: TAccordionButton): CSSObject => ({
  bg: 'alpha.700',
  color: 'white',
  px: '2',
  py: '2.5',
  transition: 'all 0.2s ease-in-out',
  borderRadius: 'base',
  fontWeight: 'semibold',
  fontSize: 'sm',

  _hover: {
    bg: 'alpha.800',
  },

  '.chakra-accordion__icon': {
    boxSize: ['4', '5'],
    border: '1px solid',
    borderColor: 'gamma.500',
    borderRadius: 'full',
    color: 'gamma.500',
    transition: '.3s ease-in-out',
  },

  _expanded: {
    color: 'white',
    bg: 'alpha.500',
    borderBottomRadius: 0,
    border: 0,
    p: '2',

    '.chakra-accordion__icon': {
      boxSize: ['4', '5'],
      borderColor: 'gamma.500',
      color: 'gamma.500',
      transition: '.3s ease-in-out',
    },
  },

  ...(isNested && {
    bg: 'alpha.500',

    _expanded: {
      bg: 'alpha.500',
      color: 'white',
      borderBottomRadius: 0,
      px: '2',
    },
  }),
});
